/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const addedModel = /* GraphQL */ `
  subscription AddedModel {
    addedModel {
      md5DateTime
      modelFilename
      modelId
      modelKey
      modelMD5
      modelMetadataMD5
      racerIdentityId
      racerName
      uploadedDateTime
    }
  }
`;
export const onAddedEvent = /* GraphQL */ `
  subscription OnAddedEvent {
    onAddedEvent {
      countryCode
      createdAt
      createdBy
      eventDate
      eventId
      eventName
      landingPageConfig {
        links {
          linkDescription
          linkHref
          linkName
        }
      }
      raceConfig {
        maxRunsPerRacer
        numberOfResetsPerLap
        raceTimeInMin
        rankingMethod
        trackType
      }
      sponsor
      tracks {
        fleetId
        leaderBoardFooter
        leaderBoardTitle
        trackId
      }
      typeOfEvent
    }
  }
`;
export const onAddedFleet = /* GraphQL */ `
  subscription OnAddedFleet {
    onAddedFleet {
      carIds
      createdAt
      createdBy
      fleetId
      fleetName
    }
  }
`;
export const onAddedRace = /* GraphQL */ `
  subscription OnAddedRace($eventId: ID!, $trackId: ID) {
    onAddedRace(eventId: $eventId, trackId: $trackId) {
      createdAt
      eventId
      laps {
        autTimerConnected
        isValid
        lapId
        resets
        time
      }
      raceId
      racedByProxy
      trackId
      userId
    }
  }
`;
export const onDeleteLeaderboardEntry = /* GraphQL */ `
  subscription OnDeleteLeaderboardEntry($eventId: ID!, $trackId: ID) {
    onDeleteLeaderboardEntry(eventId: $eventId, trackId: $trackId) {
      avgLapTime
      avgLapsPerAttempt
      countryCode
      eventId
      fastestLapTime
      lapCompletionRatio
      numberOfInvalidLaps
      numberOfValidLaps
      racedByProxy
      trackId
      username
    }
  }
`;
export const onDeletedEvents = /* GraphQL */ `
  subscription OnDeletedEvents {
    onDeletedEvents
  }
`;
export const onDeletedFleets = /* GraphQL */ `
  subscription OnDeletedFleets {
    onDeletedFleets {
      carIds
      createdAt
      createdBy
      fleetId
      fleetName
    }
  }
`;
export const onDeletedRaces = /* GraphQL */ `
  subscription OnDeletedRaces($eventId: ID!, $trackId: ID) {
    onDeletedRaces(eventId: $eventId, trackId: $trackId) {
      eventId
      raceIds
    }
  }
`;
export const onNewLeaderboardEntry = /* GraphQL */ `
  subscription OnNewLeaderboardEntry($eventId: ID!, $trackId: ID) {
    onNewLeaderboardEntry(eventId: $eventId, trackId: $trackId) {
      avgLapTime
      avgLapsPerAttempt
      countryCode
      eventId
      fastestLapTime
      lapCompletionRatio
      numberOfInvalidLaps
      numberOfValidLaps
      racedByProxy
      trackId
      username
    }
  }
`;
export const onNewOverlayInfo = /* GraphQL */ `
  subscription OnNewOverlayInfo($eventId: ID!, $trackId: ID) {
    onNewOverlayInfo(eventId: $eventId, trackId: $trackId) {
      currentLapTimeInMs
      eventId
      eventName
      laps {
        autTimerConnected
        isValid
        lapId
        resets
        time
      }
      raceStatus
      timeLeftInMs
      trackId
      userId
      username
    }
  }
`;
export const onUpdateLeaderboardEntry = /* GraphQL */ `
  subscription OnUpdateLeaderboardEntry($eventId: ID!, $trackId: ID) {
    onUpdateLeaderboardEntry(eventId: $eventId, trackId: $trackId) {
      avgLapTime
      avgLapsPerAttempt
      countryCode
      eventId
      fastestLapTime
      lapCompletionRatio
      numberOfInvalidLaps
      numberOfValidLaps
      racedByProxy
      trackId
      username
    }
  }
`;
export const onUpdatedEvent = /* GraphQL */ `
  subscription OnUpdatedEvent {
    onUpdatedEvent {
      countryCode
      createdAt
      createdBy
      eventDate
      eventId
      eventName
      landingPageConfig {
        links {
          linkDescription
          linkHref
          linkName
        }
      }
      raceConfig {
        maxRunsPerRacer
        numberOfResetsPerLap
        raceTimeInMin
        rankingMethod
        trackType
      }
      sponsor
      tracks {
        fleetId
        leaderBoardFooter
        leaderBoardTitle
        trackId
      }
      typeOfEvent
    }
  }
`;
export const onUpdatedFleet = /* GraphQL */ `
  subscription OnUpdatedFleet {
    onUpdatedFleet {
      carIds
      createdAt
      createdBy
      fleetId
      fleetName
    }
  }
`;
export const onUpdatedRace = /* GraphQL */ `
  subscription OnUpdatedRace($eventId: ID!, $trackId: ID) {
    onUpdatedRace(eventId: $eventId, trackId: $trackId) {
      createdAt
      eventId
      laps {
        autTimerConnected
        isValid
        lapId
        resets
        time
      }
      raceId
      racedByProxy
      trackId
      userId
    }
  }
`;
export const onUserCreated = /* GraphQL */ `
  subscription OnUserCreated {
    onUserCreated {
      Attributes {
        Name
        Value
      }
      Enabled
      MFAOptions {
        Name
        Value
      }
      Roles
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      sub
    }
  }
`;
export const onUserUpdated = /* GraphQL */ `
  subscription OnUserUpdated {
    onUserUpdated {
      Attributes {
        Name
        Value
      }
      Enabled
      MFAOptions {
        Name
        Value
      }
      Roles
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      sub
    }
  }
`;
export const updatedModel = /* GraphQL */ `
  subscription UpdatedModel {
    updatedModel {
      md5DateTime
      modelFilename
      modelId
      modelKey
      modelMD5
      modelMetadataMD5
      racerIdentityId
      racerName
      uploadedDateTime
    }
  }
`;
